<template>
    <div>
        <el-upload
         :action="avatarUploadUrl"
         :headers="headers"
         :before-upload="beforePicUpload"
         :on-success="handlerPicSuccess"
         :on-remove="handlePicRemove"
         list-type="picture-card"
         :limit="5"
         :on-exceed="handlePicExceed">
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import Operation from "@/request";
import fileApi from '@/request/api/file';
import userApi from '@/request/api/user';

export default {
    props: ['change'],
    data() {
        return {
            avatarUploadUrl: "",
            headers: { token: this.uploadGetToken() },
            dialogVisible: false,
            dialogImageUrl: "",
            workPictureList: [],
        }
    },
    created() {
        this.getAvatarUploadUrl();
    },
    methods: {
        //拼接头像上传地址
        getAvatarUploadUrl(){
            this.avatarUploadUrl = Operation.Const.ApiUrl+"/upload";
        },
        //获取token
        uploadGetToken() {
            if(userApi.getToken()) {
                let tokenId = userApi.getToken();
                return tokenId;
            }
        },
        //图片文件上传
        beforePicUpload(file) {
            if(!/\.(jpg|png)$/.test(file.name)) {
                this.$message({
                    message: "请上传 'jpg' 'png' 格式的图片",
                    type: 'warning'
                });
                return false;
            }
            if(file.size > 5242880) {
                this.$message({
                    message: '图片大小不能超过5M',
                    type: 'warning'
                });
                return false;
            }
        },
        //图片上传成功
        handlerPicSuccess(response, file, fileList) {
            if(response) {
                this.workPictureList.push(response);
                this.$emit('change', this.workPictureList)
            }
        },
        //删除图片
        handlePicRemove(file, fileList) {
            if(file.response) {
                fileApi.deleteFile(file.response, res => {
                    if(res.succeed) {
                        this.workPictureList.forEach((item, index) => {
                            if(item == file.response) {
                                this.workPictureList.splice(index, 1);
                                this.$emit('change', this.workPictureList)
                            }
                        })
                    }
                })

            }
        },
        //上传图片超出最大限制
        handlePicExceed(iles, fileList) {
            this.$message({
                message: '最多允许上传5张图片',
                type: 'warning'
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/upload/cardUpload.vue